(function() {
	'use strict';
	angular.module('app.setup')
		.controller('supplierLateDeliveryIssues', supplierLateDeliveryIssues);

	supplierLateDeliveryIssues.$inject = ['$scope', '$rootScope', '$timeout', '$uibModal', '$compile', 'leanFilterService', 'leanTableService', 'tableRenderService', 'tableService', 'URLS', 'supplierLateDeliveryIssueRenderService', 'supplierLateDeliveryIssueService', 'storeService', '$translate'];

	function supplierLateDeliveryIssues($scope, $rootScope, $timeout, $uibModal, $compile, leanFilterService, leanTableService, tableRenderService, 
			tableService, URLS, supplierLateDeliveryIssueRenderService, supplierLateDeliveryIssueService, storeService, $translate) {
		var adminConfig = storeService.getState().adminConfig;
		var vm = this;

		var columns = [
			{
				'id': 'description',
				'display': 'Cause',
				'width': 400,
				'renderer': supplierLateDeliveryIssueRenderService.descriptionRenderer,
				'enablePinning': false
			},
			{
				'id': 'liability',
				'display': 'Liability',
				'width': 300,
				'renderer': supplierLateDeliveryIssueRenderService.liabilityRenderer,
				'enablePinning': false,
				'sort': false
			},
			{
				'id': 'deliveryStatus',
				'display': 'Delivery status',
				'width': 300,
				'renderer': supplierLateDeliveryIssueRenderService.deliveryStatusRenderer,
				'enablePinning': false,
				'sort': false
			}
		];

		var getSpecialControl;
		var reportSettingsName = 'SupplierLateDeliveryCategories';

		vm.useSiteSwitcher = true;
		vm.searchPlaceholderText = 'Search delivery causes...';
		vm.actionButtonText = 'Add Delivery Cause';
		vm.broadcastAction = broadcastAction;
		vm.showActionButton = true;
		vm.reportName = 'Supplier Late/Early Delivery Causes';
		vm.showExcel = false;
		vm.initialLoad = true;
		vm.archiveLateDeliveryIssue = archiveLateDeliveryIssue;
		$scope.processArchive = processArchive;
		var pinnedColumns = [];
		var rendererParams = {};

		var extraParams = [{
			'name': 'showArchive',
			'value': false
		}];

		function getLiabilities() {
			return [{
				'name': 'Customer',
				'display': adminConfig.customer.name
			},
			{
				'name': 'Vendor',
				'display': $translate.instant('Vendor')
			}];
		}

		function getDeliveryStatuses() {
			return [{
				'value': 'Late',
				'display': $translate.instant('Late')
			},
			{
				'value': 'Early',
				'display': $translate.instant('Early')
			}];
		}

		var meta = {
			reportSettingsName: reportSettingsName,
			reportName: 'SupplierLateDeliveryIssues',
			noPaging: true,
			columns: columns,
			pinnedColumns: pinnedColumns,
			defaultSort: 'name',
			rendererParams: rendererParams,
			pageSize: 50,
			reportUrl: String.format(URLS.supplierLateDeliveryIssues, adminConfig.factory.id),
			searchType: 'lateDeliveryCategory',
			extraParams:extraParams,
			setColumnDefaults: true,
			getLiabilities: getLiabilities,
			getDeliveryStatuses: getDeliveryStatuses,
			specialPlaceholderText: vm.searchPlaceholderText,
			isGlobalReportSetting:true
		};

		vm.getMeta = getMeta;
		vm.getData = getData;

		function getData(params, extraParams, isFilterChanged) {
			return tableService.getData(params, extraParams).then(function (response) {
				return response;
			});
		}

		function getMeta() {
			return meta;
		}

		$scope.filterService = leanFilterService;
		$scope.tableService = leanTableService;
		$scope.tableService.setReportSettingsName(reportSettingsName);
		$scope.filterService.searchType = 'task';

		function init() {
			getSpecialControl = setInterval(getSpecialControls, 200);
			$scope.filterService.clearFilters();
			$scope.filterService.loadFilters();
		}

		function broadcastAction() {
			openNewDeliveryIssue();
		}

		function openNewDeliveryIssue() {
			var NewDeliveryIssueScope = $scope.$new();
			NewDeliveryIssueScope.action = 'Add';
			var opts = {
				scope: NewDeliveryIssueScope,
				templateUrl: '/application/f/setup/factory/general/supplier-late-delivery-issues-form.html',
				size: 'lg',
				backdrop: 'static'
			};

			var instance = $uibModal.open(opts);
			NewDeliveryIssueScope.closeDialog = function () {
				instance.close();
				NewDeliveryIssueScope.$destroy();
			};

			NewDeliveryIssueScope.result = function (message, isSuccessful) {
				instance.close();
				NewDeliveryIssueScope.$destroy();
				var time = 3000;
				$rootScope.$emit('toast', {
					'message': message,
					'success': isSuccessful,
					'time': time
				});
				if (isSuccessful) $scope.$broadcast('reloadTable');
			};

			NewDeliveryIssueScope.addToastMessage = function (message, type) {
				$rootScope.$emit('toast', {
					'message': message,
					'success': type
				});
			};
		}

		function archiveLateDeliveryIssue(lateDeliveryIssueNdx, lastModified, stateType) {
			var confirmScope = $scope.$new();
			var action = stateType === 'Archived' ? 'enable': 'archive';
			confirmScope.additionalText = action + ' this supplier delivery cause';
			confirmScope.buttonText = action.charAt(0).toUpperCase() + action.slice(1);
			var opts = {
				scope: confirmScope,
				templateUrl: '/application/f/core/confirm.html'
			};

			var instance = $uibModal.open(opts);
			confirmScope.closeDialog = function () {
				instance.close();
				confirmScope.$destroy();
			};

			confirmScope.yes = function () {
				instance.close();
				confirmScope.$destroy();
				var lateDeliveryIssue = {
					'ndx': lateDeliveryIssueNdx,
					'stateType': stateType === 'Archived' ? 'Active' : 'Archived'
				};
				supplierLateDeliveryIssueService.updateLateDeliveryIssue(lateDeliveryIssue, (new Date(lastModified)).toUTCString(), adminConfig.factory.id).then(function (response) {
					if (response && response.status && response.status >= 200 && response.status < 400) {
						$rootScope.$emit('toast', {
							'message': 'Supplier Delivery Cause ' + action + 'd successfully'
						});
						$scope.$broadcast('reloadTable');
					} else {
						$rootScope.$emit('toast', {
							'message': 'Failed to  ' + action + ' Supplier Delivery Cause.',
							'success': false
						});
					}
				});
			};
		}

		var getSpecialControls = function () {
			var specialControl = document.getElementById('specialControls');

			if (specialControl) {
				clearInterval(getSpecialControl);
				addSpecialControl();
			}
		};

		function addSpecialControl() {
			var template = '<div style=\"display: inline-block;bottom: 0px;vertical-align: bottom;line-height: 27px;position: absolute;\">' +
				'<span style=\"font-weight:bold;font-size:14px;\" translate>Show Archived</span> <input type=\"checkbox\" ng-change=\"processArchive()\" ng-model=\"showArchive\"></div>';
			var compiledDiv = $compile(template)($scope);

			jQuery('#specialControls').append(compiledDiv);
		}

		function processArchive() {
			var showArchiveIndex = _.findIndex(extraParams, ['name', 'showArchive']);
			if (showArchiveIndex !== -1) {
				extraParams[showArchiveIndex].value = $scope.showArchive;
			} else {
				extraParams.push({
					'name': 'showArchive',
					'value': $scope.showArchive
				});
			}
			$scope.$broadcast('reloadTable');
		}

		init();
	}
})();
